import { memo } from "react";
import { Box, useTheme } from "@mui/material";

// import { useAuth } from "@/client/api";
// import { Translator } from "@/components/i18n";

import { Logo } from "@/components/atoms/logo";

const WelcomeMessage = memo(() => {
  //   const { user } = useAuth();
  const theme = useTheme(); // Get theme

  return (
    <Box
      display="flex"
      position="relative"
      flexDirection="column"
      gap={1}
      pb={2}
      px={2}
      sx={{
        boxSizing: "border-box",
        width: "100%",
        maxWidth: "800px",
        margin: "auto",
        justifyContent: "center",
        color: theme.palette.text.primary, // Apply theme-aware text color
      }}
    >
      {/* Correct way to use theme in sx */}
      <Box
        sx={{
          display: "flex",
          textAlign: "center",
          justifyContent: "center",
          width: "100%",
          padding: 2,
        }}
      >
        {/* <Translator path="components.organisms.chat.WelcomeMessage.welcome" />
                <strong>{user?.display_name}</strong>
                <Translator path="components.organisms.chat.WelcomeMessage.welcome-description" /> */}
        <Logo style={{ maxHeight: "48px" }} />
      </Box>
    </Box>
  );
});

export default WelcomeMessage;
